import * as Types from '../../../gql/types2';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {"context":{"clientName":"graphql2"}} as const;
export type SingleProjectQueryVariables = Types.Exact<{
  input: Types.ProjectArgsInput;
}>;


export type SingleProjectQuery = { __typename?: 'QueryModel', projects: { __typename?: 'ProjectsQueryModel', project?: { __typename?: 'Project', actualEndDate?: string | null, actualStartDate?: string | null, afe?: string | null, po?: string | null, wo?: string | null, contractNumber?: string | null, requisitioner?: string | null, glCode?: string | null, costCenter?: string | null, billingFrequency: Types.BillingFrequencyType, block?: string | null, budget?: number | null, clientContactName: string, description: string, estimatedEndDate?: string | null, estimatedStartDate?: string | null, governmentFunding: Types.GovernmentFundingType, city: string, name: string, simplifiedName: string, networkPath?: string | null, number: number, officeCode: string, range?: string | null, section?: string | null, survey?: string | null, township?: string | null, legacyBilled: number, internalNotes: string, invoiceNotes: string, geographicLocation: string, latitude?: number | null, longitude?: number | null, canCreateInvoice: boolean, canViewInvoices: boolean, canEdit: boolean, dateIn: string, status: Types.ProjectStatus, scope: string, certifiedPayroll: boolean, projectOrigination: Types.ProjectOrigination, projectOriginationName?: string | null, allowThirdPartyInvoice: boolean, eogAfeType?: { __typename?: 'EogAfeType', gen: string, sub: string, description: string, afeType: string } | null, billingAdmin: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string }, customer: { __typename?: 'Customer', customerId: number, number?: string | null, name: string, address1: string, address2: string, state: string, city: string, zip: string, country: string, requiresEogAfeType: boolean, badDebtWriteOffs: Array<{ __typename?: 'BadDebtWriteOff', date: string, amount: number }> }, location: { __typename?: 'StateCounty', state: string, county: string }, projectManager: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string }, projectFolder?: { __typename?: 'ProjectFolder', name: string, fullPath: string, projectId: number } | null, groupedFolder?: { __typename?: 'GroupedFolder', id: number, name: string, fullPath: string } | null, expenseRateSheets: Array<{ __typename?: 'ExpenseRateSheetAssignment', effectiveDate: string, rateSheet: { __typename?: 'ExpenseRateSheet', name: string } }>, taskRateSheets: Array<{ __typename?: 'TaskRateSheetAssignment', effectiveDate: string, rateSheet: { __typename?: 'TaskRateSheet', name: string } }>, projectSupervisor: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string, userPrincipalName: string }, projectRequestApprover?: { __typename?: 'Employee', firstName: string, middleInitial: string, lastName: string } | null, stats: { __typename?: 'ProjectStats', totalUnbilled: number, totalBilled: number, totalBilledWithoutTax: number, totalPrPending: number, totalPmPending: number, totalPsPending: number, totalPostPending: number, totalBaPending: number, totalNonBillable: number, totalPostedNotBilled: number }, division: { __typename?: 'Division', id: string, name: string }, corpLocation: { __typename?: 'CorpLocation', id: string, name: string }, serviceDescription: { __typename?: 'ServiceDescription', displayName: string, industry: string, description: string, projectType: string, isOverhead: boolean, legacyWorkCode: string }, previousNames: Array<{ __typename?: 'PreviousNameHistoryItem', name: string }>, projectGroup?: { __typename?: 'ProjectGroup', name: string } | null } | null } };


export const SingleProjectDocument = gql`
    query SingleProject($input: ProjectArgsInput!) {
  projects {
    project(input: $input) {
      actualEndDate
      actualStartDate
      afe
      eogAfeType {
        gen
        sub
        description
        afeType
      }
      po
      wo
      contractNumber
      requisitioner
      glCode
      costCenter
      billingAdmin {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      billingFrequency
      block
      budget
      clientContactName
      customer {
        customerId
        number
        name
        address1
        address2
        state
        city
        zip
        country
        requiresEogAfeType
        badDebtWriteOffs {
          date
          amount
        }
      }
      description
      estimatedEndDate
      estimatedStartDate
      governmentFunding
      location {
        state
        county
      }
      city
      name
      simplifiedName
      networkPath
      number
      officeCode
      projectManager {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      projectFolder {
        name
        fullPath
        projectId
      }
      groupedFolder {
        id
        name
        fullPath
      }
      expenseRateSheets {
        effectiveDate
        rateSheet {
          name
        }
      }
      taskRateSheets {
        effectiveDate
        rateSheet {
          name
        }
      }
      projectSupervisor {
        firstName
        middleInitial
        lastName
        userPrincipalName
      }
      projectRequestApprover {
        firstName
        middleInitial
        lastName
      }
      range
      section
      survey
      township
      stats {
        totalUnbilled
        totalBilled
        totalBilledWithoutTax
        totalPrPending
        totalPmPending
        totalPsPending
        totalPostPending
        totalBaPending
        totalNonBillable
        totalPostedNotBilled
      }
      legacyBilled
      division {
        id
        name
      }
      corpLocation {
        id
        name
      }
      serviceDescription {
        displayName
        industry
        description
        projectType
        isOverhead
        legacyWorkCode
      }
      internalNotes
      invoiceNotes
      geographicLocation
      latitude
      longitude
      canCreateInvoice
      canViewInvoices
      canEdit
      dateIn
      status
      previousNames {
        name
      }
      scope
      certifiedPayroll
      projectGroup {
        name
      }
      projectOrigination
      projectOriginationName
      allowThirdPartyInvoice
    }
  }
}
    `;

/**
 * __useSingleProjectQuery__
 *
 * To run a query within a React component, call `useSingleProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleProjectQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSingleProjectQuery(baseOptions: Apollo.QueryHookOptions<SingleProjectQuery, SingleProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleProjectQuery, SingleProjectQueryVariables>(SingleProjectDocument, options);
      }
export function useSingleProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleProjectQuery, SingleProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleProjectQuery, SingleProjectQueryVariables>(SingleProjectDocument, options);
        }
export type SingleProjectQueryHookResult = ReturnType<typeof useSingleProjectQuery>;
export type SingleProjectLazyQueryHookResult = ReturnType<typeof useSingleProjectLazyQuery>;
export type SingleProjectQueryResult = Apollo.QueryResult<SingleProjectQuery, SingleProjectQueryVariables>;